<script setup>
import { useVModel, } from '@vueuse/core';
import { cn, } from '@/utils/ShadcnUtil';

import { inputVariants, } from '~/components/ui/input/index';

const props = defineProps({
  variant: { type: null, required: false, default: 'default' },
  modelValue: { type: [String, Number], required: false, default: ()=>{} },
  class: { type: null, required: false, default: '' },
});

/** ** without emitting input, we don't get to use the @input event listener on this component ****/
const emits = defineEmits(['update:modelValue', 'input']);

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <input
    v-model="modelValue"
    :class="
      cn(inputVariants({ intent: props.variant }),
         props.class,
      )
    "
    @input="$emit('input', modelValue)"
  />
</template>

<script>
export default {
  name: 'InputComponent',
};
</script>
